/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
/* eslint-disable */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Promo.css';
import Link from '../../../components/Link';

class Promo extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div
          className={s.container}
        >
          <p className={s.body}><b>Product Hunt Promo:</b> Get 50% off Habitual Premium (in-app purchase) by downloading app <a target="_blank" href="https://habitual.app.link/premium_fifty_percent_app_store"><b>HERE</b></a>. Don’t forget to upvote →</p>
          <a className={s.button} href="https://www.producthunt.com/posts/habitual?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-habitual" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=172549&theme=light" alt="Habitual - Track habits, build routines & accomplish goals. | Product Hunt Embed" width="250px" height="54px" /></a>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Promo);
